'use client'

import { NextIntlClientProvider } from 'next-intl';

import { createContext, Dispatch, ReactNode, useContext, useEffect, useState } from "react";
import koMessages from '@/messages/ko.json';
import enMessages from '@/messages/en.json';
import { langDefaultList, langTypes, sitelangs } from '@/type/lang';
import { getCookie, setCookie } from '@/util/cookie';
import { useRouter } from 'next/navigation';

export const langContext = createContext<{
    lang: string
    langList: langTypes[]
    setLangList: Dispatch<langTypes[]>
    Setlang: (lang: string) => void
}>({
    lang: "ko",
    langList: langDefaultList,
    setLangList: () => { },
    Setlang: () => { }
})

export default function LangProviders({ children }: { children: ReactNode }) {
    const [lang, setlang] = useState<string>("ko")
    const [langList, setLangList] = useState<langTypes[]>([])
    const [mountLang, setMountLang] = useState<string>()
    const messages = mountLang === 'en' ? enMessages : koMessages;

    const router = useRouter();

    function Setlang(lang: string) {
        setCookie('lang', lang, { path: "/" })
        setlang(lang)
        document.documentElement.setAttribute("lang", lang);

        if (!mountLang) {
            // 쿠키 또는 사이트 active_language 적용 후
            setMountLang(lang)
        }
    }

    useEffect(() => {
        if (!mountLang) return;

        // 초기화 이후 변경 시
        if (lang != mountLang) {
            // lang 변경 시, 새로고침
            window.location.href = window.location.pathname;
        }
    }, [lang, mountLang])

    const returnValue = {
        lang,
        Setlang,
        langList,
        setLangList
    }

    return (

        <NextIntlClientProvider locale={lang} messages={messages}>
            <langContext.Provider value={returnValue} >
                {children}
            </langContext.Provider>
        </NextIntlClientProvider>
    )
}

export const uselang = () => useContext(langContext)